<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：商品管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="出售中" name="sell">
          <span slot="label"
            >出售中 <el-tag size="mini">{{ product_count.sell }}</el-tag></span
          >
        </el-tab-pane>
        <el-tab-pane label="仓库中" name="lower">
          <span slot="label"
            >仓库中 <el-tag size="mini">{{ product_count.lower }}</el-tag></span
          >
        </el-tab-pane>
        <el-tab-pane label="回收站" name="recovery">
          <span slot="label"
            >回收站
            <el-tag size="mini">{{ product_count.recovery }}</el-tag></span
          >
        </el-tab-pane>
        <el-tab-pane label="待审核" name="audit">
          <span slot="label">待审核 <el-tag size="mini">{{product_count.audit}}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="未通过" name="no_audit">
          <span slot="label"
            >未通过
            <el-tag size="mini">{{ product_count.no_audit }}</el-tag></span
          >
        </el-tab-pane>
      </el-tabs> -->
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.category_id" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name"
              :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称"><el-input size="small" v-model="searchForm.product_name"
            placeholder="请输入商品名称"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加产品</el-button>
      <template v-if="dxlist != ''">
        <el-button @click="godeleteall()" type="danger" size="small">删除</el-button>
      </template>
      <template v-else>
        <el-button disabled type="danger" size="small">删除 </el-button>
      </template>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40" style="min-width: 100px">
          </el-table-column>
          <el-table-column prop="product_name" label="产品" width="400px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic">
                  <!-- <img v-img-url="scope.row.image" alt="" /> -->
                  <img v-img-url="existJudge(scope.row.image[0], 'file_path')" alt="" />
                </div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">¥ {{ scope.row.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="supplier.name" label="商户名称"></el-table-column>
          <el-table-column prop="category.name" label="分类"></el-table-column>
          <el-table-column prop="sku[0].yield" label="收益率"></el-table-column>
          <el-table-column prop="sales_actual" label="实际销量"></el-table-column>
          <el-table-column prop="product_stock" label="库存"></el-table-column>
          <el-table-column prop="view_times" label="点击数"></el-table-column>
          <el-table-column prop="product_status.text" label="商品属性">
            <template slot-scope="scope">
              <span v-if="scope.row.is_virtual == 0">实物商品</span>
              <span v-if="scope.row.is_virtual == 1" class="green">虚拟商品</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="发布时间"></el-table-column>
          <el-table-column prop="product_sort" label="排序"></el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <div class="table-btn-column">
                <el-button v-if="scope.row.audit_status == 10" @click="editClick(scope.row)" type="text" size="small"
                  v-auth="'/product/fastproduct/edit'">编辑商品</el-button>
                <el-button @click="delClick(scope.row)" type="text" size="small"
                  v-auth="'/product/fastproduct/delete'">删除商品</el-button>

              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
        layout="total, prev, pager, next, jumper,sizes" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import FastorderApi from "@/api/fastorder.js";
export default {
  components: {},
  data() {
    return {
      /*切换菜单*/
      activeName: "sell",
      /*切换选中值*/
      activeIndex: "0",
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: "",
        category_id: "",
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      /*商品统计*/
      product_count: {},
      dxlist: "", //多选删除订单id
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    // 多选删除
    godeleteall() {
      this.$confirm("是否要删除已选择商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          console.log("=------0");
          FastorderApi.delAllFastShop({ product_id: this.dxlist }, true).then(
            () => {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getData();
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 多选选中
    handleSelectionChange(val) {
      console.log(val, '=----val-----0');
      let dxlist = "";
      for (let dxdata of val) {
        dxlist += dxdata.product_id + ",";
      }
      this.dxlist = dxlist;
    },
    /*存在判断*/
    existJudge(data, key) {
      if (typeof data === "object" && key in data) return data[key];
      return "";
    },
    /*打开添加*/
    addClick() {
      this.$router.push("/product/fastproduct/add");
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      FastorderApi.getFastShopList(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.categoryList = data.data.category
          self.totalDataNumber = data.data.list.total;
          self.product_count = data.data.product_count;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: "/product/fastproduct/edit",
        query: {
          product_id: row.product_id,
          scene: "edit",
        },
      });
      // let routeData = this.$router.resolve({ path: '/product/product/edit', query: { product_id: row.product_id, scene: 'edit' } });
      // window.open(routeData.href, '_blank');
    },
    /*打开复制*/
    copyClick(row) {
      this.$router.push({
        path: "/product/fastproduct/edit",
        query: {
          product_id: row.product_id,
          scene: "copy",
        },
      });
    },
    /*上传素材*/
    scClick(row) {
      this.$confirm("是否要进行上传素材操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          console.log(row.product_id, row.image[0].image_id, row);
          FastorderApi.uploadimage({
            image_id: row.image[0].image_id,
            product_id: row.product_id,
          }).then((data) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /*删除*/
    delClick: function (row) {
      let self = this;
      self
        .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
          type: "warning",
        })
        .then(() => {
          FastorderApi.delFastShop({
            product_id: row.product_id,
          }).then((data) => {
            self.$message({
              message: "删除成功",
              type: "success",
            });
            self.getData();
          });
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/fastproduct/index.vue